namespace MACRAIL.Sockets {

    export class SocketHelper
    {
        private io: any;
        private connected: boolean;
        private room: string;

        constructor (io: any)
        {
            this.io = io;

            return this;
        }

        public connect(callback: any)
        {
            let self = this;

            this.io.on('connect', function() {
                self.connected = true;
                callback(self);
            });

            return this;
        }

        public emit(command: string, params: object)
        {
            this.io.emit(command, {...{
                'room': this.room,
            }, ...params});
        }

        public on(command: string, callback: any)
        {
            this.io.on(command, callback);
        }

        public isConnected()
        {
            return this.connected;
        }

        public getCurrentRoom()
        {
            return this.room;
        }

        public joinRoom(room: string, random: boolean = false)
        {
            this.room = this.generateSocketRoom(room, random);

            this.io.emit('join_room', this.room);
        }

        private generateSocketRoom(room: string, random: boolean = false)
        {
            if (random) {
                return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 6) + '-' + room;
            }

            return room;
        }
    }
}
